export default __webpack_public_path__ + "static/media/logo_einstein_horizontal.8bbc8aa3.svg";